<template>
    <div class="schedule">
        <div class="week-view" v-if="!($vuetify.breakpoint.sm || $vuetify.breakpoint.xs)">
            <div class="week-nav">
                <p class="week-range">
                    {{ currentDays[0].date | formatWeekDate }} - {{ currentDays[6].date | formatWeekDate }}
                </p>
                <v-btn @click="prevWeek" outlined small>
                    <v-icon>mdi-chevron-left</v-icon>
                    {{ $page.props.lang.prevWeek || "Prev" }}
                </v-btn>
                <v-btn @click="nextWeek" outlined small>
                    {{ $page.props.lang.nextWeek || "Next" }}
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
            <div class="grid">
                <div v-for="day in currentDays" :key="day.id + '-' + componentKeyWeek" class="item">
                    <div class="day-header" :class="{ 'active' : day.today===true}">
                        <p class="day-title">{{ day.title.substr(0,3) }}</p>
                        <p class="date">{{ day.date | formatDayDate }}</p>
                    </div>
                    <div class="day-box">
                        <Class :course="event" v-for="event in day.classes" :key="event.id"></Class>
                    </div>
                </div>
            </div>
        </div>
        <div class="day-view" v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" :key="componentKeyDay">
            <div class="day-nav">
                <p class="day-date">
                    {{ currentDay.date | formatWeekDate }}
                </p>
                <v-btn @click="prevDay" outlined small>
                    <v-icon>mdi-chevron-left</v-icon>
                    {{ $page.props.lang.prevDay || "Prev" }}
                </v-btn>
                <v-btn @click="nextDay" outlined small>
                    <v-icon>mdi-chevron-right</v-icon>
                    {{ $page.props.lang.nextDay || "Next" }}
                </v-btn>
            </div>
            <div class="item day-container">
                <div class="day-header" :class="{ 'active' : isToday}">
                    <p class="day-title">{{ currentDay.dayName.substr(0, 3) }}</p>
                    <p class="date">{{ currentDay.date | formatDayDate }}</p>
                </div>
                <div class="day-box">
                    <Class 
                    :course="course" 
                    v-for="course in currentDay.classes" :key="course.id" 
                    :style="{ backgroundColor: course.color }">
                    </Class>
                </div>
            </div>
        </div>
        <ClassDetails 
        :open="showDetailsModal" 
        :course="currentCourse"
        ></ClassDetails>
    </div>
</template>

<script>
import PortalLayout from '@/js/Layouts/PortalLayout'
import Layout from './Layout/Default'
import moment, { invalid } from 'moment'
import Class from './Components/Class'
import ClassDetails from './Components/ClassDetails'

import EventBus from '../../../eventbus';

export default {
    metaInfo() {
        return {
            title: this.organization.name + ' - ' + (this.$page.props.lang.schedule || "Schedule") 
        }
    },
    layout: (h, page) => {
      return h(PortalLayout, [
        h(Layout, [page]),
      ])
    },
    components: {
        Class, ClassDetails
    },
    props: {
        classes: Array,
        organization: Object,
        active_memberships: Array
    },
    data(){
        return {
            showDetailsModal: false,
            currentCourse: {
                trainer: {}
            },
            today: moment(),
            days: [
                { id: 0, title: this.$page.props.lang.monday || 'Monday', date: ''},
                { id: 1, title: this.$page.props.lang.tuesday || 'Tuesday', date: ''},
                { id: 2, title: this.$page.props.lang.wednesday || 'Wednesday', date: ''},
                { id: 3, title: this.$page.props.lang.thursday || 'Thursday', date: ''},
                { id: 4, title: this.$page.props.lang.friday || 'Friday', date: ''},
                { id: 5, title: this.$page.props.lang.saturday || 'Saturday', date: ''},
                { id: 6, title: this.$page.props.lang.sunday || 'Sunday', date: ''}
            ],
            currentDay: {
                date: moment(),
                dayName: '',
                classes: this.classes.filter(function(item){
                    return moment(item.start).format('DD-MM-YY') == moment().format('DD-MM-YY');
                })
            },
            componentKeyWeek: 0,
            componentKeyDay: 0,
        }
    },
    computed: {
        isToday() {
            return moment().format('DD-MM-YY')===moment(this.currentDay.date).format('DD-MM-YY') ? true : false
        },
        currentDays() {
            let daysData = Object.assign([], this.days)

            daysData.map(item => {
                if (moment().day()===0) {
                    item.date = moment().add(item.id - 6, 'days')
                } else {
                    item.date = moment().add(item.id + 1 - moment().day(), 'days')
                }
            })
            
            return daysData
        },
        onDayView: {
            get() {
                if(this.$vuetify.breakpoint.xs===true || this.$vuetify.breakpoint.sm===true) {
                    return true
                } else {
                    return false
                }
            },
            set() {
                if(this.$vuetify.breakpoint.xs===true || this.$vuetify.breakpoint.sm===true) {
                    return true
                } else {
                    return false
                }
            }
        },
    },
    created() {
        let pageUrl = new URLSearchParams(window.location.search)
        let from = pageUrl.get('from_date')
        let to = pageUrl.get('to_date')
        if (from) {
            if (this.onDayView===true) {
                this.currentDay.date = moment(from)
                this.setupDay(0)
                this.currentDay.classes = this.classes.filter(item => {
                    return moment(item.start).format('DD-MM-YY')===moment(this.currentDay.date).format('DD-MM-YY')
                })
            } else {
                this.currentDays.map((day, index) => {
                    day.date = moment(from).add(index, 'days')
                    this.setupWeek(day)
                })
            }
        } else {
            this.currentDays.map(day => {
                this.setupWeek(day)
            })
            this.setupDay(0)
        }


        EventBus.$on('SHOW_COURSE_MODAL', (p) => {
            this.currentCourse = p
            this.showDetailsModal = true
        })

        EventBus.$on('CLOSE_CLASS_MODAL', (p) => {
            this.showDetailsModal = false
        })

    },
    watch: {
        classes: function() {
            if (this.onDayView===true) {
                this.currentDay.classes = this.classes.filter(item => {
                    return moment(item.start).format('DD-MM-YY')===moment(this.currentDay.date).format('DD-MM-YY')
                })
                this.componentKeyDay += 1
            } else {
                this.currentDays.map(day => {
                    this.setupWeek(day)
                })
                this.componentKeyWeek += 1
            }
        },
        onDayView: function(value) {
            if (value===true) {
                this.currentDay.date = moment()
                this.fetchClasses(moment(this.currentDay.date).format('YYYY-MM-DD'), moment(this.currentDay.date).add(1, 'days').format('YYYY-MM-DD'))
                this.setupDay(0)
            } else {
                this.fetchClasses(moment(this.currentDays[0].date).format('YYYY-MM-DD'), moment(this.currentDays[6].date).format('YYYY-MM-DD'))
            }
        }
    },
    methods: {
        fetchClasses(from, to) {
            this.$inertia.visit('/portal/calendar?from_date=' + from + '&to_date=' + to, {
                only:['classes'], 
                preserveState: true
            })
        },
        setupWeek(day) {
            day.classes = []
            for (let i=0; i<this.classes.length; i++) {
                if (moment(day.date).format('DD-MM-YY')===moment(this.classes[i].start).format('DD-MM-YY')) {
                    day.classes.push(this.classes[i])
                }
            }
            moment(day.date).format('DD-MM-YY')===moment(this.today).format('DD-MM-YY') ? day.today = true : day.today = false
        },
        prevWeek() {
            this.currentDays.map(day => {
                day.date = moment(day.date).add(-7, 'days')
                this.setupWeek(day)
            })
            this.fetchClasses(moment(this.currentDays[0].date).format('YYYY-MM-DD'), moment(this.currentDays[6].date).format('YYYY-MM-DD'))
        },
        nextWeek() {
            this.currentDays.map(day => {
                day.date = moment(day.date).add(7, 'days')
                this.setupWeek(day)
            })
            this.fetchClasses(moment(this.currentDays[0].date).format('YYYY-MM-DD'), moment(this.currentDays[6].date).format('YYYY-MM-DD'))
        },
        async setupDay(value) {
            this.currentDay.date = moment(this.currentDay.date).add(value, 'days')
            if (moment(this.currentDay.date).day()===0) {
                this.currentDay.dayName = this.days[6].title
            } else {
                for(let i=0; i<this.days.length - 1; i++) {
                    if (moment(this.currentDay.date).day()-1===i) {
                        this.currentDay.dayName = this.days[i].title
                    }
                }
            }
        },
        prevDay() {
            this.fetchClasses(moment(this.currentDay.date).add(-1, 'days').format('YYYY-MM-DD'), moment(this.currentDay.date).format('YYYY-MM-DD'))
            this.setupDay(-1)
        },
        nextDay() {
            this.fetchClasses(moment(this.currentDay.date).add(1, 'days').format('YYYY-MM-DD'), moment(this.currentDay.date).add(2, 'days').format('YYYY-MM-DD'))
            this.setupDay(1)
        }
    },
    filters: {
        formatDayDate(value) {
            return moment(value).format('DD.MM')
        },
        formatWeekDate(value) {
            return moment(value).format('DD.MM.YYYY')
        }
    }
}
</script>